<div class="drawer">
  <button 
    class="button-primary button-primary--sm uppercase"  
    (click)="onClick()"
    [disabled]="(citationsEventService.processingAddUpdateCitation$ | async)">
    {{ (citationsEventService.processingAddUpdateCitation$ | async) ? 'Processing...' : isUpdate ? 'Update citation' : 'Insert citation' }}
  </button>
</div>